import { create } from "zustand";
import { filterInstalledIntegrationsByCategory } from "../utils/GenericFn";
import { crmList } from "../axios/constant";

export const useStoreIntegrations = create((set, get) => ({
  integrations: null,
  availableIntegrations: [],
  installedIntegrations: [],
  installedCRMIntegrations: [],
  enabledCRMIntegrations: [],
  activeDataProviderIntegrations: [],
  noIntegration: false,
  activeCRMIntegration: {},

  setIntegrations: (data) =>
    set({
      integrations: data,
      availableIntegrations: data?.available,
      installedIntegrations: data?.installed,
      activeDataProviderIntegrations: filterInstalledIntegrationsByCategory(
        data?.installed,
        "Data Providers"
      ),
      installedCRMIntegrations:
        data?.installed?.filter((item) => item?.integration?.categories?.includes("CRM")) || [],
      enabledCRMIntegrations: data?.installed?.filter(
        (item) => crmList.includes(item.integration.key) && item.is_enabled === true
      ),
      noIntegration: !data?.installed?.length,
    }),

  // 🔥 Set activeIntegration by ID
  setActiveCRMIntegrationById: (integrationId) => {
    const { installedIntegrations } = get();
    const found = installedIntegrations.find((item) => item.id === integrationId);
    set({ activeCRMIntegration: found || {} });
  },
}));
